import React from 'react';

class MapAccesor extends React.Component {
  render() {
    return null;
  }

    getMap = () => {
      return this.props.map;
    }
}

export default MapAccesor;
